import React from 'react';
import { Link } from 'react-router-dom';

/**
 * BreadcrumbNavigation
 * Visual breadcrumb UI for SEO and user navigation.
 * 
 * @param {Array} paths - Array of objects { label: 'Home', link: '/' }
 * @param {boolean} darkMode
 */
export function BreadcrumbNavigation({ paths, darkMode }) {
  if (!paths || paths.length === 0) return null;

  return (
    <nav className="flex items-center text-sm mb-4 overflow-x-auto whitespace-nowrap hide-scrollbar" aria-label="Breadcrumb">
      <ol className="flex items-center space-x-2">
        {paths.map((path, index) => {
          const isLast = index === paths.length - 1;
          
          return (
            <li key={index} className="flex items-center">
              {isLast ? (
                <span className={`font-semibold truncate max-w-[200px] sm:max-w-md ${darkMode ? 'text-gray-300' : 'text-gray-700'}`} aria-current="page" title={path.label}>
                  {path.label}
                </span>
              ) : (
                <Link to={path.link} className={`hover:underline transition-colors ${darkMode ? 'text-blue-400 hover:text-blue-300' : 'text-blue-600 hover:text-blue-800'}`}>
                  {path.label}
                </Link>
              )}
              
              {!isLast && (
                <svg className={`w-4 h-4 mx-2 ${darkMode ? 'text-gray-500' : 'text-gray-400'}`} fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
